import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import invariant from 'invariant';

import { removeContactTag } from '@/redux/app/actions/contact';
import { Tag, TagProps } from './Tag';

export type ContactTagProps = Pick<TagProps, 'name'|'color'|'external'|'search'|'searchExact'> & {
  subdomain?: string;
  contactId?: string;
  removable?: boolean;
};

export const ContactTag = ({ name, subdomain, contactId, removable, search = 'contacts', ...rest }: ContactTagProps) => {
  invariant(
    !removable || (subdomain && contactId),
    'Removable tags must have subdomain and contactId specified.',
  );
  const dispatch = useDispatch();
  const handleRemove = useCallback(() => {
    dispatch(removeContactTag(subdomain, contactId, name));
  }, [name, contactId, subdomain]);

  return (
    <Tag
      search={search}
      searchSubdomain={subdomain}
      name={name}
      handleRemove={removable && handleRemove}
      {...rest} // eslint-disable-line react/jsx-props-no-spreading
    />
  );
};
